import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import api from "./redux/common/api";
import { toast } from "react-toastify";
const firebaseConfig = {
  apiKey: "AIzaSyCZU9AE-I1Ty2UMeAOs1XjhSji11Clcpig",
  authDomain: "admissify-55e29.firebaseapp.com",
  projectId: "admissify-55e29",
  storageBucket: "admissify-55e29.firebasestorage.app",
  messagingSenderId: "461775522112",
  appId: "1:461775522112:web:961f3410a10cb13300d2a5",
  measurementId: "G-H7MCPGBREY", 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const generateDeviceToken = () => {
  let deviceToken = localStorage.getItem("device_token");
  if (!deviceToken) {
    deviceToken = `${Date.now()}-${Math.random()
      .toString(36)
      .substring(2, 15)}`;
    localStorage.setItem("device_token", deviceToken);
  }

  return deviceToken;
};

// Foreground Notifications
// onMessage(messaging, (payload) => {
//   var audio = new Audio("/notify.wav");
//   audio.play();

//   console.log("Foreground Notification Received:", payload);
//   toast.info(`🔔 ${payload.notification.title}\n${payload.notification.body}`);
// });

// Function to request permission and get token
export const requestNotificationPermission = async () => {
  try {
    const token = localStorage.getItem("access_token");

    if (!token) {
      return;
    }
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BOK04vRtWXgYURs4R6CUFOp9grH6QNUUyVuV6ALWK-PPOynqKDtItIWbL_lsnaaDT07BdeEMYbYkVUycNVZS6Hg",
      });

      // console.log("FCM Token:", token);
      const deviceToken = generateDeviceToken();
      // Send token to backend
      await api.post("/api/student/setfcntoken", {
        fcnToken: token,
        device: deviceToken,
      });

      return token;
    } else {
      console.warn("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
};

export { messaging };
